import { AdminAccessNotice } from "@/components/admin/access-notice";
import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { useIsAdmin } from "@/hooks/use-is-admin";
import { ReliabilityPanel } from "@/components/admin/reliability-panel";
import { Loader2, ShieldOff } from "lucide-react";

export const Route = createFileRoute("/admin/reliability")({
  component: AdminReliabilityPage,
  head: () => ({
    meta: [
      { title: "Chat Reliability — AskBell Admin" },
      { name: "description", content: "See how often AskBell chat turns succeed, stall, or fail, and whether the AI or a tool caused it." },
      { property: "og:title", content: "Chat Reliability — AskBell Admin" },
      { property: "og:description", content: "Success rates, durations, and failure causes for AskBell chat turns." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function AdminReliabilityPage() {
  const { isAdmin, loading, error: accessError, retry: retryAccess } = useIsAdmin();

  return (
    <AppLayout>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="mx-auto w-full max-w-5xl p-6">
          <h1 className="text-ui-2xl font-bold">Chat reliability</h1>
          <p className="mt-1 text-ui-base text-muted-foreground">
            How often chat turns finish, how long they take, and whether the AI itself or a tool is responsible when they don't.
          </p>

          <div className="mt-6">
            {loading ? (
              <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Checking access…</div>
            ) : !isAdmin ? (
              <AdminAccessNotice error={accessError} retry={retryAccess} />
            ) : (
              <ReliabilityPanel />
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
